import React, {useRef} from 'react';
import {Input, TextField} from '@mui/material';
import {getCustomers} from "../store/customers/customersSlice";
import {getCustomerProduct} from "../store/customersProducts/customersProductsSlice";
import {getAgents} from "../store/agents/agentsSlice";

const selectInputValue = (target: EventTarget | null) => {
    const el = target as HTMLInputElement | null;
    el?.select?.();
};

/**
 * Select the whole value on focus so typing replaces it.
 * Must run on the native <input> (via inputProps): a click focuses, then mouseup
 * would otherwise place the caret and collapse the selection.
 */
const useSelectAllOnFocus = (onFocus?: (e: any) => void, onMouseUp?: (e: any) => void) => {
    const pendingSelect = useRef(false);
    return {
        onFocus: (e) => {
            pendingSelect.current = true;
            selectInputValue(e.target);
            onFocus?.(e);
        },
        onMouseUp: (e) => {
            if (pendingSelect.current) {
                e.preventDefault();
                selectInputValue(e.target);
                pendingSelect.current = false;
            }
            onMouseUp?.(e);
        },
    };
};

export const NoNegative = (props) => {
    const quantityInputRef = useRef(null);
    const {changer, value, type, onFocus, onMouseUp, inputProps, ...others} = props
    const [valueDec, setValueDec] = React.useState(value);
    const selectAll = useSelectAllOnFocus(
        (e) => {
            onFocus?.(e);
            inputProps?.onFocus?.(e);
        },
        (e) => {
            onMouseUp?.(e);
            inputProps?.onMouseUp?.(e);
        }
    );

    React.useEffect(() => {
        setValueDec(value)
    }, [value]);
    return <TextField

        type='text'
        value={valueDec}

        onChange={(v) => {
            const val = v.target.value;
            // Allow empty string, numbers, and decimals
            if (/^\d*\.?\d*$/.test(val)) {
                setValueDec(val);
                if (val === '' || val === '.') {
                    changer(0);
                } else {
                    changer(Number(val));
                }
            }
        }}
        onKeyDown={(e) => {
            if (e.keyCode === 38 || e.keyCode === 40) {
                e.preventDefault();
            }
        }
        }
        onWheel={(e) => e.target.blur()}
        ref={quantityInputRef}  {...others}
        onFocus={selectAll.onFocus}
        inputProps={{
            ...inputProps,
            onMouseUp: selectAll.onMouseUp,
        }}


    />
};
export const WithNegative = (props) => {
    const quantityInputRef = useRef(null);
    const {changer, value, type, onFocus, onMouseUp, inputProps, ...others} = props
    const [valueDec, setValueDec] = React.useState(value);
    const selectAll = useSelectAllOnFocus(
        (e) => {
            onFocus?.(e);
            inputProps?.onFocus?.(e);
        },
        (e) => {
            onMouseUp?.(e);
            inputProps?.onMouseUp?.(e);
        }
    );

    React.useEffect(() => {
        setValueDec(value)
    }, [value]);
    return <TextField

        type='text'
        value={valueDec}

        onChange={(v) => {


            if (Number(v.target.value) != undefined && !isNaN(Number(v.target.value))) {
                if (v.target.value.charAt(0) == '0' && v.target.value != '0.') {
                    setValueDec(Number(v.target.value))
                } else {
                    setValueDec((v.target.value))
                }
                changer(Number(v.target.value))
            } else if (v.target.value.charAt(0) == '-' || v.target.value.endsWith("-")) {
                setValueDec("-")


            } else if (v.target.value == '') {
                changer(0)
            } else {
                setValueDec(value)
            }
        }}
        onKeyDown={(e) => {
            if (e.keyCode === 38 || e.keyCode === 40) {
                e.preventDefault();
            }
        }
        }

        onWheel={(e) => e.target.blur()}
        ref={quantityInputRef}  {...others}
        onFocus={selectAll.onFocus}
        inputProps={{
            ...inputProps,
            onMouseUp: selectAll.onMouseUp,
        }}


    />
};

export const NoNegativeInput = (props) => {
    const quantityInputRef = useRef(null);
    const {changer, value, type, onFocus, onMouseUp, inputProps, ...others} = props;
    const [valueDec, setValueDec] = React.useState(value);
    const selectAll = useSelectAllOnFocus(
        (e) => {
            onFocus?.(e);
            inputProps?.onFocus?.(e);
        },
        (e) => {
            onMouseUp?.(e);
            inputProps?.onMouseUp?.(e);
        }
    );

    React.useEffect(() => {
        setValueDec(value?.toString()); // Ensure value is treated as a string
    }, [value]);

    return (
        <Input autoComplete="off"
            type="text"
            value={valueDec}
            onChange={(v) => {
                const inputValue = v.target.value;

                // Allow only valid numeric input, including decimals
                if (/^\d*\.?\d*$/.test(inputValue)) {
                    setValueDec(inputValue);
                    changer(parseFloat(inputValue) || 0); // Convert to number only when updating
                } else if (inputValue === '') {
                    setValueDec('');
                    changer(0);
                }
            }}
            onKeyDown={(e) => {
                if (e.keyCode === 38 || e.keyCode === 40) {
                    e.preventDefault();
                }
            }}
            onWheel={(e) => e.target.blur()}
            ref={quantityInputRef}
            {...others}
            onFocus={selectAll.onFocus}
            inputProps={{
                autoComplete: 'off',
                name: 'no-autofill',
                autoCorrect: 'off',
                autoCapitalize: 'none',
                spellCheck: 'false',
                ...inputProps,
                onMouseUp: selectAll.onMouseUp,
            }}
        />
    );
};

export default NoNegative
